import { Snackbar as MuiSnackbar, type SnackbarProps as MuiSnackbarProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiSnackbarProps, 'slots' | 'slotProps'>>;

export function Snackbar(props: Props) {
  return <MuiSnackbar {...props} />;
}

export type { Props as SnackbarProps };
